export default "__VITE_ASSET__ff836d65__"